import { Price } from '@vfde-brix/core';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-fe/sails-constants';
import {
    TokenGroup,
    updateDynamicValuesInCmsContent,
} from '@vfde-fe/sails_core';
import { Offer, StateProps } from '../../DeviceDetail/interfaces/state';
import { Subscription } from '../../DeviceDetail/interfaces/api';
import {
    REGEX_ONETIMEFEE,
    REGEX_STAIRWAY_MONTH,
    REGEX_STAIRWAY_PRICE,
} from '../constants';
import {
    calculateMonthlyPriceWithoutStairway,
    hasStairway,
} from './priceHelper';

const composeLegalText = (offer: Offer | null): string => {
    const { legalTextOneTimeFee, noOneTimeFee } = window[ADDITIONAL_PAGE_OPTIONS].offerPrice;
    const legalTextTemplate = [];
    const legalTextTokens: TokenGroup = {};

    if (offer?.oneTimeFee && offer.oneTimeFee.gross > 0) {
        legalTextTokens.oneTimeFee = {
            regex: REGEX_ONETIMEFEE,
            replacement: offer.oneTimeFee.gross.toLocaleString('de'),
        };
    }

    legalTextTemplate.push(offer?.oneTimeFee && offer?.oneTimeFee.gross > 0 ? legalTextOneTimeFee : noOneTimeFee);

    return updateDynamicValuesInCmsContent(legalTextTemplate.join(' '), legalTextTokens);
};

/**
 * Stairway text
 * @param state
 */
export const composeStairwayText = (state: StateProps): string | undefined => {
    const { offer } = state;
    const { legalTextStairway } = window[ADDITIONAL_PAGE_OPTIONS].offerPrice;
    const legalTextTokens: TokenGroup = {};

    if (offer && hasStairway(offer as Offer)) {
        legalTextTokens.runtime = {
            regex: REGEX_STAIRWAY_MONTH,
            replacement: `${((offer as Offer).monetary as Exclude<Subscription['monetary'], false>)[0].runTimeEnd! + 1}`,
        };
        legalTextTokens.stairway = {
            regex: REGEX_STAIRWAY_PRICE,
            replacement: Price.fromNumber(calculateMonthlyPriceWithoutStairway(state)!).toString(),
        };

        return updateDynamicValuesInCmsContent(legalTextStairway, legalTextTokens);
    }
};

export default composeLegalText;
